export default __webpack_public_path__ + "static/media/Container Skeletal Carrier.418acb93.png";